<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <BackButton path="/" />
      </v-col>
      <v-col cols="6" class="text-align">
        <CreateRoomDialog />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <ListOfRooms />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BackButton from '@/components/BackButton.vue'
import CreateRoomDialog from '@/components/rooms/CreateRoomDialog.vue'
import ListOfRooms from '@/components/rooms/ListOfRooms.vue'

export default {
  name: 'RoomsLive',

  components: {
    BackButton,
    CreateRoomDialog,
    ListOfRooms
  }
}
</script>

<style lang="sass" scoped>
.text-align
  display: flex
  align-items: center
  justify-content: flex-end
</style>
